 import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TaskService } from '../services/tasks.service';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.css']
})
export class TasksComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private readonly route: ActivatedRoute, private readonly taskService: TaskService,
    private router: Router) {
  }
  isautoLoaded = true;
  pendingTasksCount = 0;
  pendingCountSubscriber?: Subscription;
  currentTab: string = this.router.routerState.snapshot.url;
  ngOnInit() {
    if (this.router.routerState.snapshot.url=== "/tasks") {
      this.onNavigate('pendingtasks');
    }
  }
  onNavigate(navigation: string) {
    this.isautoLoaded = false;
    this.router.navigate(['/' + navigation]);    
  }
  ngAfterViewInit(): void {
    this.pendingCountSubscriber = this.taskService.countEmitter.subscribe({
      next: (value) => {
        this.pendingTasksCount = value;
      }
    });
  } 
  ngOnDestroy(): void {
    this.pendingCountSubscriber?.unsubscribe();
  }
}
